"use client"

import styles from "./styles.module.scss";
import { PageBanner } from "../../../../../veria-nextv1/PageBanner";
import { useStoreContext } from "@/veria-nextv1/Providers/store.providers";
import { FadeInContent } from "@/veria-nextv1/Footer/FadeInContent";
import dynamic from "next/dynamic";

const NewestProducts = dynamic(() => import("../../../../../veria-nextv1/NewestProducts").then((mod) => mod.NewestProducts), 
    {
        ssr : false,
    });

const ProductsCarousel = dynamic(() => import("../../../../../veria-nextv1/ProductsCarousel").then((mod) => mod.ProductsCarousel), 
    {
        ssr : false,
    });

const Matches = dynamic(() => import("../../../../../veria-nextv1/Matches").then((mod) => mod.Matches), 
    {
        ssr : false,
    });

interface ListHomePageProps {
  homePage: any;
}

export const HomeDesktop = ({ homePage }: ListHomePageProps) =>  
{
    const { colorTableData, installmentRuleData } = useStoreContext();
    
    return (
        <main className={styles.main + " homePage"}>
            <div className={styles.content}>
                    
                <PageBanner banners={homePage?.bannersHome} />
    
                <FadeInContent />
    
                {homePage?.newsProducts?.length > 0 && (
                    <NewestProducts
                        newsProducts={homePage.newsProducts}
                        colorTable={colorTableData}
                        installmentRuleData={installmentRuleData}
                    />
                )}
                
                {homePage?.collectionProducts?.map((item: any, index:any) => (
                    <ProductsCarousel
                        key={index}
                        item={item}
                        colorTable={colorTableData}
                        installmentRuleData={installmentRuleData}
                    />
                ))}
    
                <Matches homePage={homePage} />
    
            </div>
        </main>
    );
};